export const routes = {
  signin: {
    path: '/signin',
  },
  signup: {
    path: '/signup',
  },
  verify_otp: {
    path: '/verify-challenge-otp',
  },
  verify_magic_link: {
    path: '/verify-challenge-magic-link',
  },
  forgot_password: {
    path: '/forgot-password',
  },
  forgot_password_success: {
    path: '/forgot-password/success',
  },
  reset_password: {
    path: '/password/reset',
  },
  invitation: {
    path: '/invitation',
  },
  passkey: {
    path: '/passkeysss',
  },
};
